// Explicit subjects supply context when the original button only says "Add"/"New".
const subjects = {
  pt: { whatsapp: "WhatsApp", list: "Lista", keyword: "Palavra-chave", reply: "Resposta", conversation: "Conversa", ticket: "Atendimento", contact: "Contato", user: "Usuário", task: "Tarefa", variable: "Variável", fileList: "Arquivo", option: "Opção", announcement: "Comunicado", campaign: "Campanha", activity: "Atividade", flow: "Fluxo", board: "Quadro", node: "Bloco", tag: "Tag", queue: "Fila", agent: "Agente", project: "Projeto", deal: "Negócio" },
  en: { whatsapp: "WhatsApp", list: "List", keyword: "Keyword", reply: "Reply", conversation: "Conversation", ticket: "Ticket", contact: "Contact", user: "User", task: "Task", variable: "Variable", fileList: "File", option: "Option", announcement: "Announcement", campaign: "Campaign", activity: "Activity", flow: "Flow", board: "Board", node: "Block", tag: "Tag", queue: "Queue", agent: "Agent", project: "Project", deal: "Deal" },
  es: { whatsapp: "WhatsApp", list: "Lista", keyword: "Palabra clave", reply: "Respuesta", conversation: "Conversación", ticket: "Atención", contact: "Contacto", user: "Usuario", task: "Tarea", variable: "Variable", fileList: "Archivo", option: "Opción", announcement: "Comunicado", campaign: "Campaña", activity: "Actividad", flow: "Flujo", board: "Tablero", node: "Bloque", tag: "Etiqueta", queue: "Cola", agent: "Agente", project: "Proyecto", deal: "Negocio" },
};

const aliases = {
  "lista de contatos": "Contatos",
  "contact list": "Contacts",
  "lista de contactos": "Contactos",
  "salvar configurações": "Salvar",
  "save settings": "Save",
  "guardar configuración": "Guardar",
  "guardar configuraciones": "Guardar",
  "salvar alterações": "Salvar",
  "save changes": "Save",
  "guardar cambios": "Guardar",
  "planilha exemplo": "Modelo",
  "sample spreadsheet": "Template",
  "example spreadsheet": "Template",
  "hoja de cálculo de ejemplo": "Modelo",
  // Renewing a connection is not a creation action.
  "novo qr": "Renovar QR",
  "novo qr code": "Renovar QR",
  "new qr code": "Refresh QR",
  "nuevo código qr": "Renovar QR",
};

export const compactButtonLabel = (label, { subject, language = "pt" } = {}) => {
  if (typeof label !== "string") return null;
  const trimmed = label.trim();
  const alias = aliases[trimmed.toLocaleLowerCase()];
  if (alias) return { text: alias, create: false };
  const plain = trimmed.replace(/^(?:\+|➕)\s*/, "");
  const prefix = /^(?:(?:criar|adicionar|novo|nova|create|add|new|crear|agregar|añadir|nuevo|nueva)\b[\s.]*)+/i;
  if (!prefix.test(plain)) return null;
  const noun = plain.replace(prefix, "").replace(/^(?:primeiro|primeira|first|primer|primera)\s+/i, "").replace(/\.{2,}$/, "").trim();
  const locale = subjects[language.split("-")[0]] || subjects.pt;
  const text = noun ? noun.charAt(0).toLocaleUpperCase() + noun.slice(1) : locale[subject];
  return text ? { text, create: true } : null;
};
